import { render, staticRenderFns } from "./weibo.vue?vue&type=template&id=76c26216&scoped=true"
import script from "./weibo.vue?vue&type=script&lang=js"
export * from "./weibo.vue?vue&type=script&lang=js"
import style0 from "./weibo.vue?vue&type=style&index=0&id=76c26216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c26216",
  null
  
)

export default component.exports